import { useEffect } from 'react';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import {
  toBackendLang,
  withServerErrorCode,
} from '@plone/volto/helpers/Utils/Utils';
import { useDispatch, useSelector } from 'react-redux';
import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import config from '@plone/volto/registry';

/**
 * Not found function.
 * @function NotFound
 * @returns {string} Markup of the not found page.
 */
const NotFound = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.intl.locale);

  useEffect(() => {
    dispatch(
      getNavigation(
        config.settings.isMultilingual ? `/${toBackendLang(lang)}` : '/',
        config.settings.navDepth,
      ),
    );
  }, [dispatch, lang]);

  return (
    <Container className="view-wrapper">
      <BodyClass className="page-not-found" />
      <h1>
        <FormattedMessage id="page_not_found" defaultMessage="Page not found" />
      </h1>
      <p className="description">
        <FormattedMessage
          id="page_not_found_description"
          defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not available at the moment. It might have been deleted, or the url you are trying to navigate might be incorrect"
        />
      </p>
      <p>
        <strong>
          <FormattedMessage
            id="page_not_found_keep_browsing"
            defaultMessage="You can keep browsing the website from here:"
          />
        </strong>
      </p>
      <ul>
        <li>
          <FormattedMessage
            id="page_not_found_keep_browsing_1"
            defaultMessage="Go back to the {homepage}"
            values={{
              homepage: (
                <Link to="/">
                  <FormattedMessage
                    id="homepage_link"
                    defaultMessage="homepage"
                  />
                </Link>
              ),
            }}
          />
        </li>
        <li>
          {/* Usa la barra di ricerca in alto per trovare un contenuto specifico */}
          <FormattedMessage
            id="page_not_found_keep_browsing_2"
            defaultMessage="Use the search bar at the top of the page to look for any specific content"
          />
        </li>
      </ul>
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  );
};

export default withServerErrorCode(404)(NotFound);
